import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useThemeStore = create(
	persist(
		set => ({
			isDark: false,
			toggleDark: () => set(state => ({ isDark: !state.isDark })),
			setDark: isDark => set({ isDark })
		}),
		// skipHydration: the server and first client render both use the default (light) state;
		// ThemeProvider rehydrates the persisted choice after mount to avoid hydration mismatches.
		{ name: 'polymer-theme', skipHydration: true }
	)
);
